
<template>
  <div class="mathphys_box">
    <div id="toast-container"></div>
    <div class="mathphys_">
      <!-- <div>
        <div id="myEdit" style="padding: 10px"></div>
        <el-button
          type="primary"
          size="small"
          class="btn_css"
          @click="submit_edit"
          id="getLatex"
        >
          确认</el-button
        >
      </div> -->
      <div class="mathphys_tit">
        <!-- <div class="btn_css" @click="photograph" v-loading="upload_img" element-loading-spinner="el-icon-loading">
          {{ upload_tit }}
        </div> -->
        <el-button
          type="primary"
          size="small"
          class="btn_css"
          @click="photograph('new')"
          :loading="upload_img"
        >
          {{ upload_tit }}</el-button
        >
        <!-- {{ceshi_txt}} -->
        <input
          v-show="false"
          ref="fileInput"
          type="file"
          accept="image/*"
          id="cameraInput"
        />

        <!-- capture="camera" -->

        <div class="btn_tit">{{ title }}</div>
      </div>
      <div class="mathphys_upload">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="请输入内容"
          v-model="textarea"
        >
        </el-input>

        <div class="icon_css">
          <i class="el-icon-c-scale-to-original icon_" @click="math_edit"></i>
        </div>
        <!-- <div>{{textarea}}</div> -->
        <!-- <div class="question-stem" v-html="textarea"></div> -->
        <!-- <jsCdn
          cdn="https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML"
        />
        <vue-mathjax :formula="textarea"></vue-mathjax> -->

        <div class="operation_s">
          <div class="operation_">
            <!-- <div class="btn_css" @click="answerGet" >&emsp;开始&emsp;</div> -->
            <el-button
              type="primary"
              size="small"
              class="btn_css"
              @click="answerGet"
              :loading="answerGet_loading"
              :disabled="!textarea"
            >
              {{ answerGet_tit }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              class="btn_css"
              style="margin: 0 10px"
              @click="photograph('anew')"
              :loading="upload_img_anew"
            >
              {{ upload_tit_anew }}</el-button
            >
            <!-- <input
              v-show="false"
              ref="fileInput_anew"
              type="file"
              accept="image/*"
              
            /> -->
            <!-- capture="camera" -->
            <!-- <div class="btn_css" style="margin: 0 10px">重新上传</div> -->
          </div>
          <div class="operation_">
            <div class="img_s" v-if="questionId" style="margin: 0 10px 0 0">
              <img
                v-if="status_ <= 0"
                style="transform: rotate(180deg)"
                src="../../assets/img/icon/小助手-10.png"
                alt=""
                @click="click_status(1)"
              />
              <img
                v-if="status_ > 0"
                src="../../assets/img/icon/小助手-09.png"
                alt=""
                @click="click_status(0)"
              />
              <img
                v-if="status_ >= 0"
                src="../../assets/img/icon/小助手-10.png"
                alt=""
                @click="click_status(-1)"
              />
              <img
                v-if="status_ < 0"
                src="../../assets/img/icon/小助手-09.png"
                alt=""
                style="transform: rotate(180deg)"
                @click="click_status(0)"
              />
            </div>

            <i class="el-icon-refresh-right icon_css" @click="showHand"></i>
          </div>
        </div>
        <div
          class="answer_box question-stem"
          v-loading="loading_answer"
          element-loading-text="解析中..."
          element-loading-spinner="el-icon-loading"
          v-html="response_text"
        ></div>
        
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogPrompt"
      :width="'300px'"
      :show-close="false"
      class="dialog_css"
      :close-on-click-modal="false"
    >
      <div class="dialog_tit">温馨提示</div>
      <div class="dialog_con">
        <p>
          由于目前模型的自然语言处理能力还比较菜，所以可能无法理解题目中的汉字说明，也无法正常理解与区分题目问题条件和解答项目
        </p>
        <p>
          所以如果你想要解答带有条件的题目，请使用解答功能，或许你还不太理解什么是计算题，什么是解答题，你可以先看一下下面的例题：
        </p>
        <div class="example_css" @click="goCalculate">
          <div class="example_" style="letter-spacing: 5px; margin: 0 0 0 5px">
            一些计算例题
          </div>
          <div class="example_"><i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="example_btn_s">
          <div
            class="example_btn"
            v-if="type == 'calculate'"
            @click="operate_('solve')"
          >
            跳转到解答
          </div>
          <div
            class="example_btn"
            v-else-if="type == 'solve'"
            @click="operate_('calculate')"
          >
            跳转到计算
          </div>
          <div class="example_btn" @click="dialogPrompt = false">我知道了</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogPrompt_solve"
      :width="'300px'"
      :show-close="false"
      class="dialog_css"
      :close-on-click-modal="false"
    >
      <div class="dialog_tit">温馨提示</div>
      <div class="dialog_con">
        <p>
          由于标准模型的计算力问题，含有复杂题目条件的问题可能无法顺利解答，是否在解答失败的时候自动使用高级魔性进行解答？每日使用高级模型的次数有限制（如果标准模型解答成功不消耗高级模型次数）
        </p>
        <div class="example_css" style="display: flex; justify-content: center">
          <!-- <el-checkbox v-model="solve_checked">记住我的选项</el-checkbox> -->
        </div>
        <div class="example_btn_s">
          <div class="example_btn" @click="model_('waste')">不使用</div>

          <div class="example_btn" @click="model_('use')">
            使用 {{ " (" }}{{ number_data.useHighCount }} <i>/</i>
            {{ number_data.maxHighCount }}{{ ") " }}
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogPrompt_math"
      :width="'85%'"
      :show-close="false"
      class="dialog_css" 
    >
      <MathQuill @math="handMath" ></MathQuill>
      <!-- <div id="myEdit" style="padding: 10px"></div> -->
    </el-dialog>
    <el-dialog
      :visible.sync="dialogPrompt_feedback"
      :width="'300px'"
      :show-close="false"
      class="dialog_css"
      @close="close_feedback"
    >
      <div class="dialog_tit">反馈</div>
      <div class="dialog_con">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="请输入反馈"
          v-model="textarea_feedback"
        >
        </el-input>
        <div class="example_btn_s" style="margin: 10px 0 0 0">
          <div class="example_btn" @click="dialogPrompt_feedback = false">
            取消
          </div>

          <div class="example_btn" @click="submit_feedback">确认</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import uni from "@/utils/uni.webview.1.5.2"; // 自行下载
// import { Hub, Typeset } from 'mathjax-full/js/mathjax.js';
// import 'mathjax-full/es5/tex-mml-chtml.js';
import { VueMathjax } from "vue-mathjax";
import wx from "weixin-js-sdk";
import qs from "qs";
import $ from "jquery";
import html2canvas from "html2canvas";
import MathQuill from "./components/MathQuill.vue";
export default {
  components: {
    MathQuill,
    "vue-mathjax": VueMathjax,
    jsCdn: {
      render(_) {
        return _("script", {
          attrs: {
            type: "text/javascript",
            src: this.cdn,
          },
        });
      },
      props: {
        cdn: {
          type: String,
          required: true,
        },
      },
    },
  },
  inject: ["reload"], // 注入函数
  watch: {
    $route: function (val) {
      this.reload();
    },
    question: function (value) {
      this.$nextTick(() => {
        window.MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
      });
    },
  },
  data() {
    return {
      token: "",
      type: "",
      title: "",
      textarea: "",
      status_: 0,
      dialogPrompt: false,
      dialogPrompt_solve: false,
      returnMessageAjax: "",
      upload_img: false,
      upload_tit: "拍照上传",
      upload_img_anew: false,
      upload_tit_anew: "重新上传",
      upload_type: "",
      response_text: "",
      answerGet_loading: false,
      answerGet_tit: `开始`,
      solve_num: 0,
      solve_checked: false,
      axios_url: "",
      body_data: new FormData(),
      dialogPrompt_math: false,
      file_url: "",
      questionId: "",
      dialogPrompt_feedback: false,
      textarea_feedback: "",
      feedback_static: 0,
      feedback_or: false,
      loading_answer: false,
      ceshi_txt: "",
      msg_txt: "",
      model_or: false,
      number_data: {},
      img_or: false,
      };
  },
  created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
      this.type = this.$route.query.type;
      console.log(this.type);
      if (this.type == "calculate") {
        this.title = "计算";
        this.dialogPrompt = true;
        this.axios_url =
          "http://192.168.100.212:8200/user/question/calculate/submit";
      } else if (this.type == "solve") {
        this.title = "解题";
        // this.dialogPrompt_solve = true;
        this.axios_url = "http://192.168.100.212:8200/user/question/solve/submit";
        // if (this.$route.query.model) {
        //   if (this.$route.query.model == "waste") {
        //     this.model_or = false;
        //   } else {
        //     this.model_or = true;
        //   }
        //   this.dialogPrompt_solve = false;
        // } else {
        //   this.dialogPrompt_solve = true;
        // }
        this.number_();
      } else if (this.type == "think") {
        this.title = "思路";
        this.axios_url = "http://192.168.100.212:8200/user/question/think/submit";
      }
    }
    wx.config({
      debug: false,
      appId: "wx66687bc1e1ea63cf",
      timestamp: "", // 生成签名的时间戳
      nonceStr: "", // 生成签名的随机串
      signature: "", // 签名
      jsApiList: ["chooseImage", "uploadImage"], // 需要使用的JS接口列表
    });
    wx.error(function (res) {
      console.log("微信JS-SDK注入失败:", res);
    });

    wx.ready(function () {
      console.log("微信JS-SDK注入成功");
      // 这里可以放置 wx.chooseImage 的调用代码
    });

    // this.ceshi();
    // window.document.addEventListener("operate_", () => {
    //   console.log("UniAppJSBridgeReady-->");
    //   // const [tk, id, status] = this.getQuery('params', 'hash').split('WFT')
    //   // console.log(tk, 'tk-->>')
    //   // console.log(id, 'id-->>')
    //   // console.log(status, 'status-->>')
    // });
    window.addEventListener("message", function (event) {
      console.log("Received message in H5:", event.data);
      // 处理收到的消息
    });
  },

  mounted() {
    // var mathEdit = new window.MathEdit({
    //   elId: "myEdit",
    //   config: {
    //     defaultFontSize: "18px",
    //     viewFontSize: "12px",
    //   },
    // });
    // document.getElementById("getLatex").addEventListener("click", function () {
    //   console.log(mathEdit.getLatex());
    // });
  },

  methods: {
    number_() {
      this.axios
        .get(
          "http://192.168.100.212:8200/user/question/useCount",

          {
            headers: {
              token: `${this.token}`,
            },
          }
        )
        .then((response) => {
          let res = response.data;
          console.log(res);
          if (res.code == 0) {
            this.number_data = res.data;
            if (this.model_or) {
              if (
                this.number_data.useHighCount >= this.number_data.maxHighCount
              ) {
                this.model_or = false;
              }
            }
          }
        })
        .catch((error) => {
          console.error(error);
          // 处理错误
        });
    },
    math_edit() {
      this.dialogPrompt_math = true;
    },

    click_status(i) {
      if (this.feedback_or) {
        return;
      }
      this.status_ = i;
      // console.log(i);
      // return;
      this.textarea_feedback = "";
      if (i == -1) {
        this.dialogPrompt_feedback = true;

        this.feedback_static = 2;
      } else if (i == 1) {
        this.feedback_static = 1;
        this.submit_feedback();
      } else if (i == 0) {
        this.feedback_static = 0;
        this.submit_feedback();
      }
    },
    close_feedback() {
      // console.log('a')
      if (!this.feedback_or) {
        this.status_ = 0;
      }
    },
    submit_feedback() {
      let formData_feedback = new FormData();
      formData_feedback.append("questionId", this.questionId);
      formData_feedback.append("content", this.textarea_feedback);
      formData_feedback.append("feedback", this.feedback_static);
      this.axios
        .post(
          "http://192.168.100.212:8200/user/question/feedback",
          formData_feedback,
          {
            headers: {
              token: `${this.token}`,
            },
          }
        )
        .then((response) => {
          let res = response.data;
          console.log(res);
          if (res.code == 0) {
            this.feedback_or = true;
            this.dialogPrompt_feedback = false;
          } else {
            // this.$message({
            //   type: "info",
            //   message: res.msg,
            // });
            this.showToast(res.msg);
          }
        })
        .catch((error) => {
          console.error(error);
          // 处理错误
        });
    },
    operate_(type) {
      this.$router.replace(
        {
          path: "/mathphys",
          query: {
            token: this.token,
            type: type,
          },
        },
        () => {
          this.reload(); //刷新页面
        }
      );
      // window.parent.postMessage({ type: 'solve' }, '*');
      //   wx.miniProgram.postMessage({ data: { type: type } }, "*");

      // uni.webView.postMessage({
      //   data: "Your message data",
      // });
      //   console.log(type);
    },
    photograph(type) {
      // const cameraInput = document.getElementById('cameraInput');
      // cameraInput.click();
      // return
      this.upload_type = type;
      var input = this.$refs.fileInput;
      input.click();
      //   var input = window.document.querySelector("input[type=file]");
      let that = this;
      input.addEventListener("change", function (e) {
        if (!e.target.files || e.target.files.length === 0) {
          // 用户没有选择文件
          console.log("用户没有选择文件");
          // 这里可以执行相应的操作，比如直接返回或者给出提示
          return;
        }

        var file = e.target.files[0];

        var reader = new FileReader();

        reader.onload = async function (e) {
          //   console.log(e.target.result);
          if (that.upload_type == "new") {
            that.upload_img = true;
            that.upload_tit = "识别中";
          } else if (that.upload_type == "anew") {
            that.upload_img_anew = true;
            that.upload_tit_anew = "识别中";
          }
          that.reset(that.upload_type);
          that.response_text = "";
          that.textarea = "";
          var dataURL = e.target.result;
          // var dataURL = e.target.result;
          that.file_url = that.dataURLtoFile(dataURL, "photo.jpg");
          var img = new Image();
          img.src = e.target.result;
          img.onload = async function () {
            var width = img.width;
            var height = img.height;
            console.log();
            if (width > 1000 || height > 1000) {
              // 图片宽度或高度超过1000像素，进行压缩操作
              var compressedFile = await that.compressImage(file);
              var formData = new FormData();
              
              formData.append("image", compressedFile, "photo.jpg");
              that.body_data = formData;
              this.img_or = true;
              that.file_url = compressedFile;
              that.uploadImageToBackend(formData, that.upload_type);
              // var dataURL = e.target.result;
              // that.file_url = that.dataURLtoFile(dataURL, "photo.jpg");
              // 其余代码继续处理压缩后的图片
            } else {
              // 图片宽度和高度都不超过1000像素，不进行压缩，直接使用原图
              // console.log('a')
              var formData = new FormData();
              formData.append(
                "image",
                that.dataURLtoFile(dataURL, "photo.jpg")
              );
              that.body_data = formData;
              this.img_or = false;
              that.uploadImageToBackend(formData, that.upload_type);
            }
          };
          
          //
          // var compressedFile = await that.compressImage(file);
          // var formData = new FormData();
          // // var formData = {};
          // console.log(that.type);

          // // formData.append("image", that.dataURLtoFile(dataURL, "photo.jpg"));
          // // var compressedFile = await that.compressImage(file);
          // // formData.append("image", that.compressImage(file));
          // formData.append("image", compressedFile, "photo.jpg");
          // // formData.image = that.dataURLtoFile(dataURL, "photo.jpg")
          // //
          // that.body_data = formData;

          // that.uploadImageToBackend(formData, that.upload_type);
        };
        reader.readAsDataURL(file);
      });

      //   wx.miniProgram.navigateTo({
      //     url: "/pages/questionsAsk/components/photograph",
      //   });
      //   console.log(wx)
      //   return
      //   wx.chooseImage({
      //     sourceType: ["camera"], // 选择相机
      //     success: (res) => {
      //       const tempFilePaths = res.tempFilePaths;
      //       // 上传图片
      //       console.log(tempFilePaths[0]);
      //       // this.uploadImage(tempFilePaths[0]);
      //     },
      //   });
    },
    handleCameraCapture(e) {
      let that = this;
      var file = e.target.files[0];
      that.upload_type = "new";
      var reader = new FileReader();

      reader.onload = function (e) {
        //   console.log(e.target.result);
        if (that.upload_type == "new") {
          that.upload_img = true;
          that.upload_tit = "识别中";
        } else if (that.upload_type == "anew") {
          that.upload_img_anew = true;
          that.upload_tit_anew = "识别中";
        }
        that.reset(that.upload_type);
        that.response_text = "";
        that.textarea = "";
        var dataURL = e.target.result;
        var formData = new FormData();
        console.log(that.type);
        formData.append("image", that.dataURLtoFile(dataURL, "photo.jpg"));
        that.file_url = that.dataURLtoFile(dataURL, "photo.jpg");
        that.body_data = formData;
        that.uploadImageToBackend(formData, that.upload_type);
      };
      reader.readAsDataURL(file);
    },
    goCalculate() {
      wx.miniProgram.navigateTo({
        url: "/pages/home/components/examplesList?type=calculate",
      });
    },
    dataURLtoBlob(dataURL) {
      const arr = dataURL.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    },
    compressImage(file) {
      let that = this;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function (event) {
          const img = new Image();
          img.src = event.target.result;

          img.onload = function () {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const maxWidth = 800;
            const maxHeight = 800;
            let width = img.width;
            let height = img.height;

            if (width > maxWidth || height > maxHeight) {
              const ratio = Math.min(maxWidth / width, maxHeight / height);
              width *= ratio;
              height *= ratio;
            }

            canvas.width = width;
            canvas.height = height;

            ctx.clearRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);

            const compressedDataURL = canvas.toDataURL(file.type);
            const compressedBlob = that.dataURLtoBlob(compressedDataURL);

            resolve(compressedBlob);
          };

          img.onerror = function (error) {
            reject(error);
          };
        };

        reader.onerror = function (error) {
          reject(error);
        };
      });
    },

    dataURLtoFile(dataURL, fileName) {
      var arr = dataURL.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], fileName, { type: mime });
    },
    uploadImageToBackend(formData, type) {
      // return
      this.axios
        .post(
          "http://192.168.100.212:8200/user/question/latex/extract",
          formData,
          {
            headers: {
              token: `${this.token}`,
            },
          }
        )
        .then((response) => {
          let res = response.data;
          if (res.code == 0) {
            // formatLatex();

            this.textarea = res.data;
            this.$nextTick(function () {
              if (!this.MathJax.isMathjaxConfig) {
                //判断是否初始配置，若无则配置。
                this.MathJax.initMathjaxConfig();
              }
              this.MathJax.MathQueue("question-stem");
            });
          } else {
            // this.$message({
            //   type: "info",
            //   message: res.msg,
            // });
            this.showToast(res.msg);
          }
          if (type == "new") {
            this.upload_img = false;
            this.upload_tit = "拍照上传";
          } else if (type == "anew") {
            this.upload_img_anew = false;
            this.upload_tit_anew = "重新上传";
          }
        })
        .catch((error) => {
          console.error(error);
          // 处理错误
        });
    },
    MathJax_txt() {
      this.$nextTick(function () {
        if (!this.MathJax.isMathjaxConfig) {
          //判断是否初始配置，若无则配置。
          this.MathJax.initMathjaxConfig();
        }
        this.MathJax.MathQueue("question-stem");
      });
    },
    answerGet() {
      let that = this;
      if (!that.textarea) {
        return;
      }
      let data = {
        text: that.textarea,
        image: that.file_url,
      };
      console.log(that.file_url);
      that.answerGet_loading = true;
      that.answerGet_tit = "解析中";
      that.loading_answer = true;
      let dataForm = new FormData();
      dataForm.append("text", that.textarea);
      if (that.file_url) {
        if (that.img_or) {
          dataForm.append("image", that.file_url , "photo.jpg");
        } else {
          dataForm.append("image", that.file_url);
        }
      }
      if (that.upload_type == "anew") {
        dataForm.append("retry", true);
      }
      if (that.title == "解题" && this.model_or) {
        dataForm.append("useShowHand", true);
      }

      // return;
      that.returnMessageAjax = $.ajax({
        url: that.axios_url, // 线上地址
        // data: qs.stringify(data),
        data: dataForm,
        // timeout: 80000, // 请求超时时间
        type: "POST",
        // dataType: "json",
        processData: false,
        contentType: false,
        xhrFields: {
          onprogress: (e) => {
            var content = "";
            var end = false;
            var items = e.currentTarget.response.split("\n");
            for (var i = 0; i < items.length; i++) {
              var item = items[i];
              if (item === "" || item.indexOf("data:") < 0) continue;

              item = item.substring(item.indexOf("data:") + 5);
              var data = JSON.parse(item);
              console.log(data);
              if (data.questionId) {
                that.questionId = data.questionId;
                // console.log(data);
              }

              // return
              //   if (!questionId) {
              //     questionId = data.questionId;
              //     document.getElementById("questionId").innerHTML = questionId;
              //   }

              if (data.act === "next") {
                content += data.text;
              } else if (data.act === "end") {
                end = true;
                that.answerGet_loading = false;
                that.answerGet_tit = "开始";
              }
            }
            // console.log();
            that.response_text = content;
            if (that.loading_answer) {
              that.loading_answer = false;
            }
            if (!end) {
              that.MathJax_txt();
            }
          },
          onload: (e) => {
            console.log(e);
          },
        },
        timeout: 1000 * 60 * 5,
        headers: {
          token: that.token,
          // "content-type": "multipart/form-data; boundary=--------------------------226330397828241332097274",
        },
        complete: function (XMLHttpRequest, status) {
          console.log(XMLHttpRequest);
          if (status === "timeout") {
            // alert("请求超时");
            // that.$message.error("请求超时");
            this.showToast("请求超时!");
            this.answerGet_loading = false;
            this.answerGet_tit = "开始";
            this.loading_answer = false;
          } else if (status === "parsererror") {
            // that.time_(that.end_time, "end");
            // that.stop_();
          } else if (status === "error") {
            // console.log("请求报错");
          }
        },
        success: function (data) {
          console.log(data);
        },
      });
    },
    model_(type) {
      // if (this.solve_checked) {
      //   // window.sessionStorage.setItem('solve_model', 'use')
      //   wx.miniProgram.postMessage({ data: { model: "use", type: type } }, "*");
      // }
      if (this.returnMessageAjax) {
        this.returnMessageAjax.abort();
        // this.returnMessageAjax.cancel('destroyed');
      }
      if (type == "waste") {
        this.model_or = false;
      } else {
        this.model_or = true;
        if (this.number_data.useHighCount >= this.number_data.maxHighCount) {
          this.showToast("高级模型次数已用完!");
          return;
        }
      }
      // this.showToast('高级模型次数已用完!');
      //     return
      this.dialogPrompt_solve = false;
      this.answerGet();
      this.questionId = "";
    },

    toImgStyle(base64Str, fileName) {
      var arr = base64Str.split(","),
        mime = arr[0].match(/:(.*?);/)[1], // base64解析出来的图片类型
        bstr = atob(arr[1]), // 对base64串进行操作，去掉url头，并转换为byte atob为window内置方法
        len = bstr.length,
        u8arr = new Uint8Array(len);

      while (len--) {
        u8arr[len] = bstr.charCodeAt(len);
      }
      // console.log("mime:", mime);
      // console.log("bstr:", bstr);
      // 使用Blob创建有效的File对象
      const blob = new Blob([u8arr], { type: mime });
      console.log("bstr:", blob);
      // 创建新的 File 对象实例[utf-8内容，文件名称或者路径，[可选参数，type：文件中的内容mime类型]]
      return blob;
    },
    handMath(data) {
      console.log("math:", data);
      this.body_data = new FormData();
      this.textarea = data;
      this.body_data.append("text", data);
      this.dialogPrompt_math = false;
      // this
      this.answerGet();
    },
    showHand() {
      this.dialogPrompt_solve = true;
    },
    reset(type) {
      if (this.returnMessageAjax) {
        this.returnMessageAjax.abort();
        // this.returnMessageAjax.cancel('destroyed');
      }

      this.textarea = "";
      this.response_text = "";
      this.answerGet_loading = false;
      this.answerGet_tit = "开始";
      this.questionId = "";
      this.feedback_or = false;
      this.loading_answer = false;
      if (type == "all") {
        this.upload_img = false;
        this.upload_tit = "拍照上传";
        this.upload_img_anew = false;
        this.upload_tit_anew = "重新上传";
      } else if (type == "new") {
        this.upload_img_anew = false;
        this.upload_tit_anew = "重新上传";
      } else if (type == "anew") {
        this.upload_img = false;
        this.upload_tit = "拍照上传";
      }
    },
    submit_edit() {
      return;
      window.pageYoffset = 0; //网页位置
      document.documentElement.scrollTop = 0; //滚动条的位置
      document.body.scrollTop = 0; //网页被卷去的高
      // **加上面三行代码和setTimeOut是为了解决获取的图片只能获取可视区域内容的坑**
      setTimeout(() => {
        html2canvas(document.querySelector(".non-italicized-function"))
          .then((canvas) => {
            console.log(canvas);
            let base64Img = canvas.toDataURL(); //将canvas转为base64
            console.log(base64Img);
            // 直接将 Blob 对象传递给 FormData
            let formdata = new FormData();
            // console.log()
            formdata.append(
              "image",
              this.toImgStyle(base64Img, Date.now() + ".png")
            );
            console.log(formdata);
            this.uploadImageToBackend(formdata);
            // 其他处理...
          })
          .catch((error) => {
            console.error("Error capturing screenshot:", error);
          });
        return;

        // axios("http://xxxxxxxxx:8080/api/xxxxxxx/update", {
        //   data: formdata,
        //   method: "post",
        //   type: "json",
        // }).then((res) => {
        //   console.log("res", res);
        // });
      }, 100);
    },
    async downloadImage() {
      const contentElement = document.querySelector(".box_p");

      if (!contentElement) {
        console.error('Element with class "download-content" not found.');
        return;
      }

      try {
        const canvas = await html2canvas(contentElement);
        const dataURL = canvas.toDataURL();

        // Create a temporary link and trigger a click to download the image
        const a = document.createElement("a");
        a.href = dataURL;
        a.download = "downloaded_image.png";
        a.click();
      } catch (error) {
        console.error("Error capturing screenshot:", error);
      }
    },
    showToast(message, duration = 3000) {
      var toastContainer = window.document.getElementById("toast-container");

      toastContainer.textContent = message;
      // this.msg_txt = message
      toastContainer.style.display = "block";

      setTimeout(function () {
        toastContainer.style.display = "none";
      }, duration);
    },
  },
};
</script>

<style　  lang="less" scoped>
.mathphys_box {
  display: flex;
  justify-content: center;
  .mathphys_ {
    max-width: 800px;
    padding: 30px;
    width: 100%;
  }
}
.mathphys_tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn_css {
  background: #0aaf88;
  border-color: #0aaf88;
  color: white;
  padding: 12px 20px;
  border-radius: 5px;
  display: inline-block;
  width: 95px;
}
.btn_tit {
  font-weight: 600 !important;
  font-size: 24px !important;
  color: rgb(37, 37, 37) !important;
  letter-spacing: 3px;
}
.mathphys_upload {
  margin: 20px 0;
}
.operation_s {
  margin: 10px 0 0 0;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 18px;
    margin: 0px 5px 0 0px;
    position: relative;
    top: 2px;
  }
}
.img_s {
  display: inline-block;
}
.icon_css {
  font-size: 21px;
}
.answer_box::-webkit-scrollbar {
  display: none;
}
.answer_box {
  margin: 10px 0;
  height: calc(100vh - 330px);
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  overflow-x: hidden;
  overflow-y: scroll;
  text-align: left;
  line-height: 25px;
  white-space: pre-line;
}
.dialog_tit {
  background: #67cab3;
  color: #353535;
  height: 60px;
  line-height: 60px;
  text-align: center;
  letter-spacing: 3px;
  font-weight: 600;
  font-size: 20px;
  border-start-start-radius: 10px;
  border-start-end-radius: 10px;
}
.dialog_con {
  padding: 15px 20px;
  p {
    line-height: 24px;
    text-indent: 2em;
    text-align: left;
  }
}
.example_css {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
  color: #353535;
  /deep/ .el-checkbox__original {
    display: none;
  }
}
.example_btn_s {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.example_btn {
  background: #0aaf88;
  border-color: #0aaf88;
  color: white;
  padding: 8px 15px;
  border-radius: 5px;
  width: 100px;
  display: inline-block;
}
.dialog_css {
  /deep/ .el-dialog {
    border-radius: 10px;
  }

  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 0;
    border-radius: 10px;
  }
}
.question-stem {
  white-space: pre-line;
}
/deep/ #mathDiv {
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;

  min-height: 90px;
  // line-height: 40px;
  outline: none;
  padding: 0 20px;
  margin: 10px 0 0 0;
}
/deep/ .mathquill-rendered-math {
  width: 100%;
  text-align: left;
  border: none;
  // background-color: #fff;
  // background-image: none;
  // border-radius: 4px;
  // border: 1px solid #dcdfe6;
  // box-sizing: border-box;
  // color: #606266;
  // // display: inline-block;
  // font-size: inherit;
  // height: 10px;
  // line-height: 10px;
  // outline: none;
  // padding: 0 15px;
}
/deep/ .hasCursor {
  box-shadow: none;
}
/deep/ .mathIcon {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
/deep/ .tabMenu {
  width: 100% !important;
}
/deep/ .math_one {
  height: auto !important;
}
/deep/ .tabTitle li {
  width: 30% !important;
}
.icon_css {
  position: relative;
}
.icon_ {
  position: absolute;
  top: -20px;
  right: 3px;
}
#toast-container {
  position: fixed;
  bottom: 50%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  display: none;
  z-index: 5005;
}

</style>